import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';
import styled from '@emotion/styled';
import Field from '@base/Form/Field';
import { InputAdornment } from '@material-ui/core';
import CountryMenu from '@cont/Login/CountryMenu';
import useForm from '@base/Form/useForm';
import { Spacings, mediaQuery } from '@styles/index';
import { LOGIN_DRAWER } from '@constants/toggleables';
import { useToggleable } from '@stores/toggleables';
import { getSetLocalPhoneNumber } from '@stores/selectors/login';
import useLoginStore from '@stores/login/loginStore';
import { ContinueButon, Error, StyledNumberField } from './styles';
import { isLengthMatchError, isRequired } from './utils';
import { DEFAULT_COUNTRY } from '../constants';

const Wrapper = styled.div`
  grid-column: 13/23;
  max-height: 314px;
  padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_6B};
  background: var(--color-base-1);
  border: 1px solid var(--color-i-gray-v2);
  border-radius: ${Spacings.SPACING_2B};
  margin-top: ${Spacings.SPACING_20B};

  ${mediaQuery.uptoMobile} {
    grid-column: 1/25;
    padding: ${Spacings.SPACING_8B};
    margin: ${Spacings.SPACING_3B};
    margin-top: ${Spacings.SPACING_10B};
    margin-bottom: ${Spacings.SPACING_6B};
  }
`;

const StyledP1 = styled(P1)`
  margin-top: ${Spacings.SPACING_3B};
  color: var(--color-text-secondary);
  margin-bottom: ${Spacings.SPACING_6B};
`;

const renderErrorMessage = ({ message }) => {
  return <Error>{message}</Error>;
};

const FieldWrapper = styled.div`
  margin-top: ${Spacings.SPACING_8B};
`;

const formState = {
  phone: ''
};

const LoginModal = ({ buttonText = 'Submit' }) => {
  const { registrar, isSubmitting, onFormSubmit } = useForm({
    data: formState
  });

  const { openElement: openLoginDrawer } = useToggleable(LOGIN_DRAWER);
  const setLocalPhoneNumber = useLoginStore(getSetLocalPhoneNumber);
  const onSubmit = async (data) => {
    setLocalPhoneNumber(String(data.phone), DEFAULT_COUNTRY);
    openLoginDrawer();
  };
  const handleOnSubmit = onFormSubmit(onSubmit);

  return (
    <Wrapper>
      <H4>Log in to your account or sign up</H4>
      <StyledP1>To continue, enter your mobile number</StyledP1>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name="phone"
          rules={[
            isRequired('Mobile number is required'),
            isLengthMatchError('Please enter a valid mobile number', 10)
          ]}
          render={({ onChange, value, hasError }) => (
            <StyledNumberField
              fullWidth
              startAdornment={
                <InputAdornment>
                  <CountryMenu country={DEFAULT_COUNTRY} disabled />
                </InputAdornment>
              }
              placeholder="Enter your mobile number"
              onChange={(_, data) => onChange(data)}
              value={value}
              inputProps={{
                type: 'tel',
                maxLength: 10,
                required: true
              }}
              type="tel"
              error={hasError}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
      <ContinueButon
        onClick={handleOnSubmit}
        width="100%"
        variant={isSubmitting ? 'disabled' : 'filled'}
        label={buttonText}
        color="black"
      />
    </Wrapper>
  );
};

export default LoginModal;
